import { useGraphqlQuery } from "@bsm/component"
import { TDescriptor } from "@bsm/graphql"
import { CurrenciesQuery } from "queries/CurrenciesQuery"

export const useCurrenciesQuery = (suspense?: boolean) => {
    return useGraphqlQuery<CurrenciesQuery, Array<TDescriptor>>(new CurrenciesQuery(), { suspense })
}
